import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { HrSearchButtonsComponent } from './hr-search-buttons.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [HrSearchButtonsComponent],
    imports: [CommonModule, ToolbarModule, ButtonModule, TranslateModule],
    exports: [HrSearchButtonsComponent],
})
export class HrSearchButtonsModule {}
